import React, {useContext} from 'react';
import themeContext from '../../context/themeContext';

const Darkmode = () => {
    const {setDarkTheme} = useContext(themeContext)

    const switchTheme = (e) => {
        document.querySelector('body').classList.toggle("light");
        setDarkTheme((prev) => !prev);
    }
    return (
        <button id="darkmode" onClick={(e) => switchTheme(e)}>
           <img className="light-icon" src={`${process.env.PUBLIC_URL}/images/icons/sun-01.svg`} alt="Sun images" />
           <img className="dark-icon" src={`${process.env.PUBLIC_URL}/images/icons/vector.svg`} alt="Sun images" />
        </button>
    )
}
export default Darkmode;
